import React, { useState, forwardRef, useImperativeHandle } from "react";
import {TextField,
        FormHelperText,
        FormControl,
        InputLabel,
        Grid,
        InputAdornment,
        Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        Checkbox,
        FormControlLabel,
        Chip,
        CircularProgress
} from "@material-ui/core";
import {
    Send as SendIcon,
    Message as MessageIcon
} from '@material-ui/icons'

import { toast } from "react-toastify";
import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';

const JobCompletion = forwardRef((props, ref) => {
    const { closeMenu, onCompleteSuccess } = props;
    const classes = useStyles();
    const [jobId, setJobId] = useState(-1);
    const [openCompleteJobDialog, setOpenCompleteJobDialog] = useState(false);
    const [isCompleting, setIsCompleting] = useState(false);
    const [createXeroInvoice, setCreateXeroInvoice] = useState(true);

    useImperativeHandle(ref, () => ({

      openCompletionPopup(jobId) {
        console.log(jobId);
        setJobId(jobId);
        handleClickJobCompletionPopup();
      }

    }));


    const handleClickJobCompletionPopup = () => {
      closeMenu();
      setOpenCompleteJobDialog(true);
    };

    const handleCloseCompleteJob = () => {
      setOpenCompleteJobDialog(false);
    };

    const handleCompleteJob = async() => {
      setIsCompleting(true);
      const response = await ttAPI.completeJob(jobId);
      setIsCompleting(false);

      if (response === undefined || response == null ||
    		  response.data === undefined || response.data === null ||
          !response.data.success) {

      }
    	if (response && response !== null && response.success) {
          sendNotification('success', `Success - Job ${jobId} Completed.`, classes);
          handleCloseCompleteJob();

          // // TODO:
          if (createXeroInvoice) {
              window.open(`${config.clientApi}/xero.html?jobId=${jobId}`,'_blank');
              /*if (config.clientApi.includes('uat')) {
                  window.open(`${config.clientApi}/xero.html?jobId=${jobId}`,'_blank');
              }
              else {
                  window.open(`http://app.testandtag.co.nz/client/xero.html?jobId=${jobId}`,'_blank');
              }*/
          }
          onCompleteSuccess();
      }
      else {
          sendNotification('error', `Error - Job ${jobId} NOT Completed. Exception: ${response && response !== null && response.message && response.message !== null ? response.message : ''}`, classes);
          handleCloseCompleteJob();
      }
    };

    function handleCreateXeroInvoiceChecked(e) {
        setCreateXeroInvoice(e.target.checked);
    }

  return (
    <>
    <Dialog open={openCompleteJobDialog} onClose={handleCloseCompleteJob} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle id="form-dialog-title">Complete Job</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to complete job {jobId}
        </DialogContentText>
        <DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={createXeroInvoice}
                onChange={handleCreateXeroInvoiceChecked}
                name="create_xero_invoice"
                color="primary"
              />
            }
            label="Create Xero Invoice"
          />
        </DialogContentText>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseCompleteJob} className={classes.cancelButton}>
          Cancel
        </Button>
          <Button onClick={handleCompleteJob} disabled={isCompleting}>
            {isCompleting && <span><CircularProgress size={25}/> Completing...</span>}
            {!isCompleting && <span>Complete</span>}
          </Button>
      </DialogActions>
    </Dialog>
    </>
  );
});
export default JobCompletion;
